import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import UserIcon from '@BUP/assets/Icons/user_icon.svg'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import PeriodsTable from '@BUP/components/CourseAssignment/PeriodsTable'
import { useGetPeriods } from '@BUP/hooks/CourseAssignment/useGetPeriods'
import { useReopenPeriod } from '@BUP/hooks/CourseAssignment/useReopenPeriod'
import { useClosePeriod } from '@BUP/hooks/CourseAssignment/useClosePeriod'

/**
 * Own screen for the course-assignment period history (every grade, open and closed), split out
 * from the period dashboard - which only ever shows each grade's current period.
 */
const CourseAssignmentPeriodsPage = () => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.data.courseAssignmentPeriodDashboard' })
  const navigate = useNavigate()

  const { isLoading, error, periods } = useGetPeriods()
  const { mutateAsync: reopenPeriod, isPending: isReopening } = useReopenPeriod()
  const { mutateAsync: closePeriod, isPending: isClosing } = useClosePeriod()

  return (
    <PageLayout>
      <>
        <div style={{ marginBottom: '1rem' }}>
          <ButtonComponent
            buttonText={t('backToPeriodButton')}
            colorType='tertiary'
            size='small'
            onClick={() => navigate('/course-assignment/period')}
          />
        </div>
        <TitleDashboard icon={UserIcon} text={t('historyTitle')} />
        <p>{t('historyIntro')}</p>
        <PeriodsTable
          isLoading={isLoading}
          error={error}
          periods={periods}
          onReopen={reopenPeriod}
          isReopening={isReopening}
          onClose={closePeriod}
          isClosing={isClosing}
          onViewResponses={(period) => navigate(`/course-assignment/responses?periodId=${period.id}`)}
        />
      </>
    </PageLayout>
  )
}

export default CourseAssignmentPeriodsPage
